import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

// IDs are taken from the manually registered SEO CMS RBAC pages.
export const SEO_CMS_CATEGORY_LIST_PAGE_ID = 'e3c07e315c21968de195ba9de65e19d4'
export const SEO_CMS_CATEGORY_DETAIL_PAGE_ID = 'a94a2091665dfe469125a2b5882ab49e'
export const SEO_CMS_CATALOGUE_LIST_PAGE_ID = '8a097dd88bab76d12b99323b3a5f2177'
export const SEO_CMS_CATALOGUE_DETAIL_PAGE_ID = 'a4576d878a2cf7d05eb6fe009a3cca23'
export const SEO_CMS_DLP_LIST_PAGE_ID = '52de73057f8baa08840ba1144166aacc'
export const SEO_CMS_DLP_DETAIL_PAGE_ID = '1a47209878fb075f44d8a4e63a4a7476'
export const SEO_CMS_HOME_PAGE_ID = 'f3dc4b256ac07ed65d4ad0d1d74c27d9'

export const SeoCmsCategoryListRBAC = {
  pageID: SEO_CMS_CATEGORY_LIST_PAGE_ID,
  elementID: {
    View: 'f8d773972c1837ebb3b5e5b7e1e54f9f',
    ViewFaq: 'ae786f8d785dfe46902e61a1758afe41',
    ViewDescription: 'c80c094f473f0535b077e4be9b1a81c3',
    PublishBtn: '0870510e4e350389037592083b6cd1af',
    ViewDetail: '0e21fbf26f34f63034bc8fe87fc0b5cc',
    PublishAll: '0870511144350389037592083b6ef2b6',
  },
} as const

export const SeoCmsCategoryDetailRBAC = {
  pageID: SEO_CMS_CATEGORY_DETAIL_PAGE_ID,
  elementID: {
    View: '98d8ad985061b8d9aff0d4a019c095f9',
    Publish: '213a689611780ca65a8880761f662dbb',
  },
} as const

export const SeoCmsCatalogueListRBAC = {
  pageID: SEO_CMS_CATALOGUE_LIST_PAGE_ID,
  elementID: {
    PublishAll: 'a7f746b9ef9ffe9f5e74c16119756f31',
    View: 'f08452857602a7043a44b6973ace2fa0',
    ViewFaq: 'bab43f42e82cf7d05e372265d304de40',
    ViewDescription: '17b0d194ce54290fc46b3ebd2e16c52e',
    PublishBtn: 'a7f746bbf59ffe9f5e74c16119766948',
    ViewDetail: 'd789d9407c9ff145a89a9c6220f68d83',
  },
} as const

export const SeoCmsCatalogueDetailRBAC = {
  pageID: SEO_CMS_CATALOGUE_DETAIL_PAGE_ID,
  elementID: {
    View: '01cdf100b8f2f940c7755f39d0df88d4',
    Publish: '9aa47d4ae0cb12d8ec4b40693b8722f4',
  },
} as const

export const SeoCmsDlpListRBAC = {
  pageID: SEO_CMS_DLP_LIST_PAGE_ID,
  elementID: {
    ViewFaq: 'a5b6de5e8afb075f45d6c4eef388b279',
    ViewDescription: 'a883c4b2b2f2407b65dd5d48c2eb575b',
    PublishBtn: 'a72269daa0ac0a9916ea4b2c7e408587',
    ViewDetail: 'f6e3d80af1abfced47d3904846ae57f4',
    PublishAll: 'a72269dda6ac0a9916ea4b2c7e42bade',
    View: '2903edab1e21968de17e1bb3bb3a62e7',
  },
} as const

export const SeoCmsDlpDetailRBAC = {
  pageID: SEO_CMS_DLP_DETAIL_PAGE_ID,
  elementID: {
    View: '96fc4fc7ec59ac46d5a6e99ddf488a01',
    Publish: 'be7ef50d66aaecafd27a641903bb5ab3',
  },
} as const

export const SeoCmsHomeRBAC = {
  pageID: SEO_CMS_HOME_PAGE_ID,
  elementID: {
    View: '258bed42bef5664853abdc7bbf3a5702',
    Publish: 'f2910be6be664df1f72c2469f7a05eb6',
  },
} as const

export const useRBACSeoCmsCategoryList = createUseRBAC(SeoCmsCategoryListRBAC.elementID)
export const useRBACSeoCmsCategoryDetail = createUseRBAC(SeoCmsCategoryDetailRBAC.elementID)
export const useRBACSeoCmsCatalogueList = createUseRBAC(SeoCmsCatalogueListRBAC.elementID)
export const useRBACSeoCmsCatalogueDetail = createUseRBAC(SeoCmsCatalogueDetailRBAC.elementID)
export const useRBACSeoCmsDlpList = createUseRBAC(SeoCmsDlpListRBAC.elementID)
export const useRBACSeoCmsDlpDetail = createUseRBAC(SeoCmsDlpDetailRBAC.elementID)
export const useRBACSeoCmsHome = createUseRBAC(SeoCmsHomeRBAC.elementID)
